import type { ReactNode } from 'react';

/**
 * Marks a link that opens a new tab: a small up-right arrow, and the same fact
 * in words for screen readers (willow.tech's nav does this too). It goes inside
 * the <a>, right after the text, and takes the link's color.
 *
 * In running text, pass the link's last word as `children`, so the arrow can't
 * wrap onto a line of its own.
 */
export function ExternalLinkIcon({ children }: { children?: ReactNode }) {
  const arrow = (
    <svg className="external-link-icon" viewBox="0 0 10 10" aria-hidden="true" focusable="false">
      <path d="M2.5 7.5l5-5M3.5 2.5h4v4" />
    </svg>
  );
  return (
    <>
      {children ? (
        <span className="external-link-end">
          {children}
          {arrow}
        </span>
      ) : (
        arrow
      )}
      <span className="visually-hidden"> (opens in a new tab)</span>
    </>
  );
}
